<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="600"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">{{ $t("assign_carrier") }}</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--begin::Modal header-->
      <!--begin::Modal body-->
      <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
        <!--begin::Body-->
        <div class="row">
          <div class="col-12 col-12 h-75px">
            <v-select
              v-model="carrier_id"
              :label="$t('select_carrier')"
              item-text="text"
              item-value="index"
              :items="carriers"
              clearable
              outlined
              dense
              :error-messages="carrier_id_errors"
              @input="checkValidity"
              @blur="checkValidity"
            ></v-select>
          </div>
          <div class="col-12 col-12 h-75px">
            <v-select
              v-model="carrier_account_id"
              :label="$t('carrier_account')"
              item-text="text"
              item-value="index"
              :items="carrierAccountItems"
              :disabled="!carrier_id"
              clearable
              outlined
              dense
              :error-messages="carrier_account_id_errors"
              @input="checkValidity"
              @blur="checkValidity"
            ></v-select>
          </div>
        </div>
        <!--end::Body-->

        <!--begin::Actions-->
        <div class="my-4 d-flex flex-grow-1 align-end justify-center">
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submit"
          >
            {{ $t("submit") }}
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import swalEdited from "@/core/services/AlertServices/SwalEdited";

export default {
  name: "AssignCarrier",
  props: ["items", "updateTableContent"],
  data: () => ({
    dialog: false,
    carrier_id: null,
    carrier_account_id: null,
    valid: true,
  }),
  methods: {
    toggleModal() {
      this.reset();
      this.dialog = !this.dialog;
    },
    submit() {
      this.checkValidity();
      if (this.valid) {
        this.$store.commit(SET_PAGE_LOADING, true);
        const payload = {
          ids: this.items.map((item) => item.id),
          carrier_id: this.carrier_id,
          carrier_account_id: this.carrier_account_id,
        };
        ApiService.post(`/shipping/pickup_orders/assign-carrier`, payload)
          .then(({ data }) => {
            if (data.hasOwnProperty("error_orders")) {
              let editedItemMessage = `<div><ol>`;
              data.messages.forEach((item) => {
                editedItemMessage += `<li>${item}</li>`;
              });
              editedItemMessage = editedItemMessage + `</ol></div>`;
              Swal.fire({
                title: this.$t("result"),
                html: editedItemMessage,
                icon: data.error_orders === 0 ? "success" : "warning",
                showConfirmButton: true,
              });
            } else swalEdited();
            // Swal.fire({
            //   title: "Success",
            //   text: `${data.message}`,
            //   icon: "success",
            //   showConfirmButton: true,
            //   // timer: 2500,
            // });
            this.toggleModal();
            this.updateTableContent();
          })
          .catch(() => {
            this.$store.commit(SET_PAGE_LOADING, false);
          });
      }
    },
    checkValidity() {
      if (!this.carrier_id || !this.carrier_account_id) {
        this.valid = false;
      } else {
        this.valid = true;
      }
    },
    reset() {
      this.carrier_id = null;
      this.carrier_account_id = null;
      this.valid = true;
    },
  },
  watch: {
    carrier_id() {
      this.carrier_account_id = null;
      this.checkValidity();
    },
  },
  computed: {
    carriers: function () {
      return this.$store.getters.getPICKUPORDERSCarriers;
    },
    carrier_id_errors: function () {
      if (!this.valid && !this.carrier_id) {
        return this.$t("validation_this_field_is_required");
      }
      return null;
    },
    carrier_account_id_errors: function () {
      if (!this.valid && !this.carrier_account_id) {
        return this.$t("validation_this_field_is_required");
      }
      return null;
    },
    carrierAccountItems: function () {
      if (!this.carrier_id) return [];

      return this.$store.getters.getPICKUPORDERSCarrierAccounts.filter(
        (account) => account.carrier_id === this.carrier_id
      );
    },
  },
  mounted() {},
};
</script>
